// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"1a624ac6","213":"fb7e6f0f","329":"7503838c","609":"e48e18d0","657":"9f32d601","750":"664a1b75","812":"8389d7a6","887":"2a8aa135"}[chunkId] + ".chunk.js";
};